import { checkPredictiveBalanceCompany } from "../../infrastructure/repository/company-repository";
import { logError, addContextLog } from "../../infrastructure/log";

export async function checkBalance() {
  try {
    const { data } = await checkPredictiveBalanceCompany();
    const { predictiveBalance, blockedBalance } = data;
    addContextLog("info", "checkBalance", "process", predictiveBalance);
    return { predictiveBalance, blockedBalance };
  } catch (e) {
    return logError(e, "Error to checkBalance");
  }
}
